import { inject, Injectable, signal, Signal, WritableSignal } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs/operators';
import { pairwise } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PreviousRouteService {
  public activatePreviousRoute: WritableSignal<boolean> = signal(false);
  private readonly router: Router = inject(Router);

  public readonly previousUrl: Signal<string | undefined> = toSignal(
    this.router.events.pipe(
      filter((event: RoutesRecognized) => event instanceof RoutesRecognized),
      pairwise(),
      map((events: [RoutesRecognized, RoutesRecognized]) => events[0].urlAfterRedirects)
    )
  );

  public setPreviousRouteActivation(): void {
    this.activatePreviousRoute.set(true);
  }

  public navigateToPreviousRoute(): void {
    this.router.navigateByUrl(this.previousUrl());
    this.clearPreviousRouteActivation();
  }

  private clearPreviousRouteActivation(): void {
    this.activatePreviousRoute.set(false);
  }
}
